// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui' //element-ui的全部组件
import 'element-ui/lib/theme-chalk/index.css'//element-ui的css
import globalMsg from './global.js'
import router from './router'
import axios from "axios";
import Container from 'element-ui';
import echarts from 'echarts'

Vue.use(ElementUI) ;//使用elementUI
Vue.use(Container);

Vue.prototype.$globalMsg = globalMsg;
Vue.config.productionTip = false;
Vue.prototype.$echarts = echarts
axios.defaults.withCredentials = true;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js